import { Turnstile, TurnstileProps } from "@marsidev/react-turnstile";

export const TurnstileCompat = (props: TurnstileProps) => {
  return <Turnstile {...props} />;
};
